import React, { useMemo } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import CrushShyPageHead from '../../components/CrushShyPageHead';
import { crushshySeo } from '../../seo/crushshySeo';
import { useLanguage } from '../../context/LanguageContext';
import { useCrushShyT } from '../../hooks/useCrushShyT';

const { invite } = crushshySeo;

const CrushShyRdv = () => {
  const [params] = useSearchParams();
  const code = (params.get('code') || '').trim().toUpperCase();
  const t = useCrushShyT();
  const { toggleLanguage } = useLanguage();

  const description = useMemo(() => {
    if (!code) return 'Rejoins un RDV CrushShy avec le code partagé par ton ami.';
    return `Rejoins le RDV CrushShy avec le code ${code}. Ouvre l'app CrushShy pour voir uniquement les participants sur la carte.`;
  }, [code]);

  return (
    <>
      <CrushShyPageHead title="RDV CrushShy" description={description} path="/crushshy/rdv" />
      <div className="min-h-screen bg-[#090B16] text-white px-6 py-16 max-w-lg mx-auto text-center">
        <div className="flex justify-end mb-4">
          <button
            type="button"
            onClick={toggleLanguage}
            className="text-xs font-semibold px-2.5 py-1 rounded-md border border-pink-500/30 text-pink-300 hover:bg-pink-500/10"
          >
            {t('langToggle')}
          </button>
        </div>
        <p className="text-xs font-bold uppercase tracking-widest text-pink-400 mb-4">CrushShy</p>
        <h1 className="text-2xl font-bold mb-4">Mode RDV</h1>
        <p className="text-gray-300 text-sm leading-relaxed mb-6">{description}</p>
        {code ? (
          <p className="text-3xl font-mono font-bold text-pink-400 tracking-widest mb-8" aria-label="RDV code">
            {code}
          </p>
        ) : null}
        <p className="text-sm text-gray-500 mb-8">
          Ouvre l'app CrushShy — le code sera proposé automatiquement si le lien est reconnu.
        </p>
        <Link to="/crushshy" className="inline-block text-pink-400 hover:underline text-sm">
          {t('inviteLearnMore')}
        </Link>
      </div>
    </>
  );
};

export default CrushShyRdv;
